import filterStyles from './components/shared-components/dropdown/filter-dropdown/FilterDropdown.module.css'
import images from './assets/images/index'
import DatePicker from "react-datepicker";
import { UnfoldMore } from "@mui/icons-material";
import { Checkbox, CircularProgress, Menu, MenuItem, Paper, Select, TableCell, TableHead, TableRow, TableSortLabel, TextField, styled, tableCellClasses } from "@mui/material";
import { useContext, useEffect } from "react";
import styles from '../src/components/shared-components/table/AppTable.module.css'
import "react-datepicker/dist/react-datepicker.css";
import CancelButton from './components/shared-components/buttons/CancelButton';
import SubmitButton from './components/shared-components/buttons/SubmitButton';
import { LeagueObjectType } from './components/shared-components/dropdown/filter-dropdown/ManageTicketFilterDropdown';
import moment from 'moment';
import 'moment-timezone';
import axios from 'axios';
import { globalContext } from './Provider/AppProvider';
import { AffiliateType } from './components/shared-components/dropdown/filter-dropdown/AffiliateFilterDropdown';
import { formatDbEventDate, formatDbEventTime } from './utils/eventDbDateTime';
const HtmlToReactParser = require('html-to-react').Parser;

export interface PageData {
  [pathname: string]: {
      title: string;
      metaDescription: string;
  };
}

export type rowsType = {
    u_id: string,
    u_active_tickets: number,
    u_country_code: string,
    u_created_at: string,
    u_email_id: string,
    u_first_name: string,
    u_is_active: boolean,
    u_last_name: string,
    u_last_online: string | null,
    u_phone_number: string,
    u_full_name: string
    u_is_verified: boolean,
    u_delete_requested:boolean,
    u_total_earnings: number | null,
    tickets_sold_amount:number | null,
    u_stripe_account_id : string | null,
    u_stripe_business_name: string | null,
    tickets_aggregate: {
      aggregate: {
        sum: {
          t_active_tickets: number,
          t_sold_tickets: number
        }
      }
    },
    user_referred_to: {
      ur_joining_code : string,
      user_referred_by :{
        u_full_name : string ,
        u_first_name : string ,
        u_last_name : string
      }
    },
    user_referred_by_aggregate: {
      aggregate: {
        count: number
      }
    }
  };
  
export type listTicketsRowType = {
  e_name: string,
  l_name: string | null,
  e_date: string,
  e_address: string,
  e_time_zone: string,
  e_date_time_zone?: string | null,
  e_time?: string | null,
  tp_section: string,
  tp_row: string,
  tp_seat_no: string,
  u_id: string,
  u_first_name: string,
  u_last_name: string,
  e_id: string,
  t_id: string,
  tp_id: string,
  u_full_name: string
  u_email_id: string
  tp_list_price : number
  tp_status: string,
  tp_delist_requested_email: string,
  u_original_email:string
  e_status:string
  tp_is_support_vanderbilt_nil_fund: boolean
}

export type soldTicketsRowType = {
    e_name: string,
    l_name: string,
    e_date: string,
    e_address: string,
    e_time_zone: string,
    e_date_time_zone?: string | null,
    e_time?: string | null,
    tp_section: string,
    tp_row: string,
    tp_seat_no: number,
    tp_status:string,
    u_id: string,
    u_first_name: string,
    u_last_name: string,
    e_id: string,
    t_id: string,
    tp_id: string,
    u_full_name: string,
    u_email_id: string,
    tp_logitix_amount: number,
    tp_sold_amount: number,
    tp_payment_status: string | null
    tp_list_price : number,
    tp_quick_cut_amount: number,
    e_status:string,
    tp_payout_status: 'Voided_Payout' | 'Unvoided_Payout',
    tp_is_support_vanderbilt_nil_fund: boolean
}

export const PayoutType = {
  VOIDED_PAYOUT: 'Voided_Payout',
  UNVOIDED_PAYOUT: 'Unvoided_Payout'
}
  type paymentTransaction = {
    transactionId: string;
    status: string;
    paymentUpdated: string;
    payementId: string;
    stripe_transfers: {
      st_invoice: string
    }
  }

  type eventDetails = {
    eventName: string;
    eventDate: string;
    eventAddress: string;
    eventId: string;
  };

export type invoiceDetailsProps = {
        tp_id: string,
        tp_logitix_amount: number,
        tp_sold_amount: number,
        tp_quick_cut_amount: number,
        payment_transaction: [
         paymentTransaction
        ],
        seatNo: string,
        section: string,
        row: string,
        ticket: {
          event: eventDetails
        }
};
export type EditTicketType = {
     tp_id: string,
     tp_row: string,
     tp_seat_no: number,
     tp_section: string,
     tp_status: string,
     ticket: {
          event: {
              e_address: string,
              e_name: string,
              e_cdt_date_with_year: string,
              e_status: string,
              e_date: string,
              e_id: string
            },
          user: {
              u_full_name: string,
              u_email_id: string
            }
        }
};
export type affiliateUserRowType = {
  u_uid: string,
  u_first_name: string,
  u_last_name: string,
  u_email_id: string,
  u_refer_link: string,
  u_no_of_users: number,
  u_affiliate_id : string
}
  
  interface UserType{
    u_role: string; 
    __typename: string;
  }
  
  export type manageticketsrowType ={   
      e_name: string,
      l_name:string| null,
      e_date: string,
      e_address: string,
      e_time_zone: string,
      e_date_time_zone?: string | null,
      e_time?: string | null,
      tp_section: string,
      tp_row: string,
      tp_seat_no: string,
      u_id: string,
      u_first_name: string,
      u_last_name: string,
      tp_validity_status: boolean,
      tp_status:string| null,
      tp_is_published: boolean,
      tp_delist_requested_email: string,
      e_id:string,
      t_id: string,
      tp_id: string,
      full_name: string,
      u_email_id: string,
      u_original_email:string,
      e_status:string,
      user : UserType
      tp_is_support_vanderbilt_nil_fund: boolean
  }

  export type eventsRowType = {
    e_id: string;
    e_name: string;
    e_date: string;
    e_time_zone: string;
    e_date_time_zone?: string | null;
    e_time?: string | null;
  }

export type VenuesRowType = {
  ltv_name: string;
  ltv_id: string;
  ltv_is_active: string;
  ltv_updated_at: string;
  all_venue?: Venue | null;
}
export interface Venue {
    av_id: string;
    av_name: string;
    av_street: string;
    av_city: string;
    av_country_code: string;
    av_zipcode: string;
    av_timezone: string;
    av_state_code: string;
    av_venue_ref_id: string;
    av_latitude: number;
    av_longitude: number;
}


// export const emailRegexPattern = /^(("[\w-\s]+")|([a-zA-Z]+[\w-]*(?:\.[\w-]+)*)|("[\w-\s]+")([a-zA-Z]+[\w-]*(?:\.[\w-]+)*))(@((?:[a-zA-Z-]+\.)*[a-zA-Z][a-zA-Z-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/
export const emailRegexPattern = /^(("[\w-\s]+")|([a-zA-Z0-9.+]+[\w-]*(?:\.[\w-]+)*)|("[\w-\s]+")([a-zA-Z0-9.+]+[\w-]*(?:\.[\w-]+)*))(@((?:[a-zA-Z0-9-]+\.)*[a-zA-Z0-9-][a-zA-Z0-9-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/

export const passwordRegexPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>])[A-Za-z\d!@#$%^&*()\-_=+{};:,<.>.]{0,}$/;

export const amountRegexPattern = /^[0-9]+(\.[0-9]+)?$/

export const transactionPattern =/^[\w\d-]+$/

export interface NotificationProps{
    notificationData: NotificationDataType[],
    handleClose: () => void
  }

  export interface notificationData {
    f_id: string;
      title: string;
      type: string;
      u_id?: string;
      notification: string;
      user_feeds?: userfeeds[];
      tp_id_array:any
      ticket_placement: {
        tp_id: string;
      };
      ticket: {
        t_id: string;
        user?: {
          u_id?: string;
          pricingMode?: string | null;
        };
        ticket_placements?: {
          tp_internal_notes?: string | null;
          tp_external_notes?: string | null;
        }[];
        event: {
          eventImage: string;
          eventName: string;
          eventDate: string;
          eventAddress: string;
          e_id: string;
          eventStatus:string;
        };
      };
  }

  interface tableCellProp{
    id: string,
    label: string,
    className: string
}
 export interface NotificationDataType {
    notificationData?: [notificationData];
    handleClose: () => void;
  }
  
  interface userfeeds {
    user: {
      userId: string;
      userName: string;
    };
  }

  export interface questionById{
    faq_id: string,
    faq_question: string,
    faq_answer: string
  }
export const CustomTextField =() => {
    return (
        styled(TextField, { shouldForwardProp: (prop) => prop !== 'error' })(({ theme, error }) => ({
            color: "#E3E5E8",
            '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: error ? '#EF4444' : '#E3E5E8', // Set the desired border color for hover
            },
            '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                borderColor: error ? '#EF4444 !important' : '#E3E5E8 !important', // Set the desired border color for hover
                borderWidth: "1px",
            },
        }))
    );
}

export const minLengthValidation = {
  value: 8,
  message: "Password should be atleast 8 characters"
}
export const maxLengthValidation = {
  value: 30,
  message: "Password should not exceed 30 characters"
}

export const CustomPaperComponent = (isFitContent: boolean = false) => {
  if(isFitContent) {
    return(
      styled(Paper)`& { border-radius: 0px;max-width: fit-content} `
    );
  } else {
    return(
      styled(Paper)`& { border-radius: 0px;} `
    );
  }
}


export const StyledTableCellhelper = () => {
  return styled(TableCell)(({ theme }) => ({
    border: "none",
    fontFamily: "Glegoo",
    color: "var(--table-text-color)",
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "var(--table-header-bg)",
      color: "var(--table-header-text) !important",
      whiteSpace: "nowrap",
      paddingLeft: '13px',
      fontWeight: 700,
      fontSize: '14px'
    },
    "&:last-child": {
      position: "sticky",
      right: 0,
      boxShadow: "-3px -6px 9px 4px rgba(15, 23, 42, 0.08)",
      textAlign : 'center',
      minWidth : '110px',
      backgroundColor: "var(--table-sticky-bg)",
      color: "var(--table-text-color)"
    }
  }));
};

export const NonStickyStyledTableCellhelper = () => {
  return styled(TableCell)(({ theme }) => ({
    border: "none",
    fontFamily: "Glegoo",
    color: "var(--table-text-color)",
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "var(--table-header-bg)",
      color: "var(--table-header-text) !important",
      whiteSpace: "nowrap",
      paddingLeft: '13px',
      fontWeight: 700,
      fontSize: '14px'
    },
  }));
};

export const StyledTableRowhelper = () => {
  return styled(TableRow, {
    shouldForwardProp: (prop) => prop !== 'isSuperUserData',
  })<{ isSuperUserData?: boolean }>(({ isSuperUserData }) => ({

    fontSize: '14px !important',
    cursor: 'pointer',
    fontFamily: 'Glegoo',

    ...(!isSuperUserData && {
      '&:nth-of-type(odd)': {
        backgroundColor: 'var(--table-row-odd-bg)',
        fontFamily: 'Glegoo',
        color: 'var(--table-text-color)',
      },
      '&:nth-of-type(even)': {
        backgroundColor: 'var(--table-row-even-bg)',
        fontFamily: 'Glegoo',
        color: 'var(--table-text-color)',
      },
      '& td': {
        border: 0,
        fontFamily: 'Glegoo',
        color: 'var(--table-text-color)',
      },
    }),

    ...(isSuperUserData && {
      '&:nth-of-type(odd)': {
        backgroundColor: '#eff8e6ff',
        fontFamily: 'Glegoo',
      },
      '&:nth-of-type(even)': {
        backgroundColor: '#e6f3dbff',
        fontFamily: 'Glegoo',
      },
      '& td': {
        border: 0,
        fontFamily: 'Glegoo',
      },
    }),

    '&.Mui-selected:nth-of-type(odd)': {
      backgroundColor: isSuperUserData ? '#eff8e6ff' : 'var(--table-selected-bg)',
      fontFamily: 'Glegoo',
      color: 'var(--table-text-color)',
    },

    '&.Mui-selected:nth-of-type(even)': {
      backgroundColor: isSuperUserData ? '#e6f3dbff' : 'var(--table-selected-bg)',
      fontFamily: 'Glegoo',
      color: 'var(--table-text-color)',
    },

    '&.Mui-selected:hover:nth-of-type(odd)': {
      backgroundColor: isSuperUserData ? '#eff8e6ff' : 'var(--table-selected-bg)',
      fontFamily: 'Glegoo',
      color: 'var(--table-text-color)',
    },

    '&.Mui-selected:hover:nth-of-type(even)': {
      backgroundColor: isSuperUserData ? '#e6f3dbff' : 'var(--table-selected-bg)',
      fontFamily: 'Glegoo',
      color: 'var(--table-text-color)',
    },
  }));
};


export const InputPropsStyleForInvoice = {
  borderRadius: 12,
  fontFamily: "Glegoo",
  fontSize:
    "var(--body-b2-14-semibold-left-size)",
  fontWeight: 400,
  color: "var(--color-neutral-1000)",
}

export const InputPropsForAddAffiliates = {
  borderRadius: 0,
  fontFamily: "Glegoo",
  fontSize: "var(--body-b2-14-semibold-left-size)",
  border:0
}
export const DropdownIndicator = (id: string) => {
  return (
    <>
      {(id !== 'action' && id !== 'validate' && id !== 'tp_section' && id !== 'reason' && id !== 'earnings' 
        && id !== 'sold_tickets_count' && id !== 'sold_amount' && id !== 'ut_transaction_id' && id !== 'ut_transaction_amount'
        && id !== 'ut_transaction_date' && id !== 'ut_type' && id !== 'ut_transaction_status' && id !== 'ut_invoice_number' && id !== 'ut_payout_status' && id !== 'tp_is_support_vanderbilt_nil_fund'
      ) ? (
        <div className={styles.unfoldmoreicon}>
          <UnfoldMore fontSize="small" />
        </div>
      ) : (
        <div className={styles.nosortingicon}></div>
      )}
    </>
  );
}

export const handleonKeyDownForEmailId = (e: any, moduleName: string) => {
  let notAllowedKeysRegex;
  // eslint-disable-next-line no-useless-escape
  if(moduleName === 'addAffiliate'){
    notAllowedKeysRegex = /^[A-Z!#$%^&*()_{}\[\]:;<>,?~\/\\]+$/;
  }else {
    notAllowedKeysRegex = /^[A-Z!#$%^&*()_{}\[\]:;<>,?~\/\\]+$/;
  }
  
  if (notAllowedKeysRegex.test(e.key)) {
    e.preventDefault();
  }
}
export const StyledSelectDropdown = () => {
  return styled(Select)(() => ({
    width: '120px',
    height: '44px',
    fontFamily: 'Glegoo',
    '&.MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: 'transparent', // Remove hover effect
      },
      '&.Mui-focused fieldset': {
        borderWidth: 0, // Remove outline when focused
      },
      '& fieldset': {
        border: 'none', // Remove border
      },
    },
    '& .MuiSelect-select': {
      paddingRight: 'unset', // Adjust as needed to prevent the icon from shifting due to border removal
    },
  }))
}

export const StyledSelectDropdownforError = () => {
  return styled(Select)(() => ({
    width: '110px',
    height: '30px',
    padding : '6px 0px 5px 0px',
    borderRadius: '0px',
    fontSize: '14px',
    fontFamily: 'Glegoo',
    '&.MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#B9BDB6', // Remove hover effect
      },
      '&.Mui-focused fieldset': {
        border: '1px solid #B9BDB6' // Remove outline when focused
      },
    },
    '& .MuiSelect-select': {
      paddingRight: 'unset', // Adjust as needed to prevent the icon from shifting due to border removal
    },
  }))
}



export type ResponseItem =  {
  leagueName: string;
  totalCounts: number;
}

export interface BarChartItem {
  name: string;
  uv: number;
  fill: string;
}

export interface RevenueChart {
  name : string;
  uv: number;
  ticketCount: number;
  revenueAmount: number;
}

export const specificColors: { [key: string]: string } = {
  'nodata': '#F3F4F6',
  "MLB": "#12AFAB",
  "MLS": "#FFBF00",
  "NBA": "#FF7910",
  "NFL": "#19AF28",
  "NHL": "#2A9ADA",
  "WNBA": "#A124D3",
  "WWE" : "#5D75F8",
  "Concert" : "#FFFF00",
  "Theatres": "#FF69B4"
};

// Predefined list of colors to cycle through
export const predefinedColors: string[] = [
  "#32CD32", "#4682B4", "#9932CC", "#FF8C00", "#008080",
  "#FF69B4", "#4B0082", "#FFFF00", "#00FF00", "#800000",
  "#000080", "#FF00FF", "#808080", "#800080"
];

export const extractLeagues = ['WWE','Theatres','Concert'];

export const GenerateBarChartValue = (response : ResponseItem[]): BarChartItem[] => {
  const names: string[] = response
  .filter((item) => !extractLeagues.includes(item?.leagueName))
  .map((item) => item?.leagueName);
  const colors: string[] = names.map((name, index) => {
    if (specificColors.hasOwnProperty(name)) {
      return specificColors[name];
    }
    return predefinedColors[index % predefinedColors.length];
  });

  const uvValues: number[] = response.filter((item) => !extractLeagues.includes(item?.leagueName)).map(item => item?.totalCounts);
  return names.map((name: string, index: number): BarChartItem => ({
    name,
    uv: uvValues[index],
    fill: colors[index], 
  }));
};


function TicketPlacementHeader(cell : tableCellProp, createSortHandler: any){
  let splitValues: string[] = [];
  if(cell?.label){
    splitValues = cell?.label.split(',');
  }
  return(
    <TableSortLabel
              onClick={createSortHandler(cell?.id)}
              IconComponent={() => DropdownIndicator(cell?.id)}
              className={
                (cell?.id === "action") 
              ? styles.headcellAction 
              : ((cell?.id === 'tp_section') || (cell?.id === 'validate') || (cell?.id === 'reason') || (cell?.id === 'earnings')) 
                ? styles.headCellPlacement 
                : styles.headerLabel}
            >
              <div className={styles.parentContainer}>
              <div>
              {splitValues && splitValues[0]}
              </div>
              <div className={styles.ticketplacementLine}></div>
              <div className={styles.secRowSeat}>
                <span>{splitValues[1]}</span>
                <span>{splitValues[2]}</span>
                <span className={styles.seatHeaderStyle}>{splitValues[3]}</span>
              </div>
              </div>
    </TableSortLabel>
  );
}

/* For get the table headers */
export function EnhancedTableHead(props: any) {
const {globalState,handleGlobalState} = useContext<any>(globalContext)
const StyledTableCell = StyledTableCellhelper();
const NonStickyTableCell = NonStickyStyledTableCellhelper();
  const { onSelectAllClick, numSelected, rowCount, onRequestSort,checking, setChecking , generateHeadCells,tableTitle, purpose} = props;
  const createSortHandler = (property: string) => (event: React.MouseEvent) => {
    onRequestSort(event, property);
  };
  useEffect(()=>{
    if(numSelected === rowCount){
      setChecking(true);
    }else{
      setChecking(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[numSelected,rowCount])
  
  return (
    <TableHead>
      <TableRow>
        {((tableTitle === 'users' && globalState.profile.userRole !== roles.AFFILIATER_ADMIN) || (tableTitle === 'managetickets' && globalState.profile.userRole!==roles.SUPER_USER) || (tableTitle === "listtickets" && globalState.profile.userRole === roles.SUPER_USER) || tableTitle === 'pickEvents' || tableTitle === 'pickEventsBulkList')
        ? <StyledTableCell padding="checkbox">
              <Checkbox
                classes={{
                  colorPrimary: styles.unselectCheckbox,
                  checked: styles.selectedCheckbox,
                }}
                disableRipple
                checked={checking}
                onChange={onSelectAllClick}
                inputProps={{
                  "aria-label": "select all users",
                }}
                sx={{
                  paddingLeft: "5%"
                }}
                style={{display: tableTitle === 'pickEvents' ? 'none' : 'block'}}
                data-testid = 'GlobalIcon'
              />
            </StyledTableCell>
        : '' 
        }
        { tableTitle === 'stripePaymentsError' || tableTitle === 'scrapEventError' || tableTitle === 'stripePayoutError'|| tableTitle === 'stripePayoutSuccess'|| tableTitle === 'delistAndReturnTickets'|| tableTitle === 'delistAndUnsoldTickets' || (globalState.profile.userRole === roles.AFFILIATER_ADMIN && tableTitle === 'users' || tableTitle === "affiliateTransactions" || tableTitle === 'affiliatePopup' || ((tableTitle === 'pickEvents') && (purpose && purpose === 'addTickets')) || tableTitle === 'pickEventsBulkList' || tableTitle === 'manualTicketsError' ||(tableTitle === 'managetickets' && globalState.profile.userRole === roles.SUPER_USER) || (tableTitle === "auditLogitixLogs") ||(tableTitle === 'listtickets' && globalState.profile.userRole === roles.SUPER_USER))
        ?
          generateHeadCells()?.map((headCell: tableCellProp) => (
            <NonStickyTableCell
              key={`${headCell?.id}-${headCell?.label}`}
              size="small"
            >
              {
                headCell?.label?.includes("Ticket Placements")
              ? TicketPlacementHeader(headCell,createSortHandler)
              :
              <TableSortLabel
                onClick={createSortHandler(headCell?.id)}
                IconComponent={() => DropdownIndicator(headCell?.id)}
                className = { 
                (headCell?.id === "action")
              ? styles.headcellAction 
              : ((headCell?.id === 'tp_section') || (headCell?.id === 'validate') || (headCell?.id === 'reason'))
                  ? styles.headCellPlacement 
                  : styles.headerLabel
              }
              >
                {headCell?.label}
              </TableSortLabel>
            }
            </NonStickyTableCell>
          ))
        :
        generateHeadCells()?.map((headCell: tableCellProp) => (
          <StyledTableCell
            key={`${headCell?.id}-${headCell?.label}`}
            size="small"
          >
            {
              headCell?.label?.includes("Ticket Placements")
            ? TicketPlacementHeader(headCell,createSortHandler)
            :
            <TableSortLabel
              onClick={createSortHandler(headCell?.id)}
              IconComponent={() => DropdownIndicator(headCell?.id)}
              className = { 
               (headCell?.id === "action")
             ? styles.headcellAction 
             : ((headCell?.id === 'tp_section') || (headCell?.id === 'validate') || (headCell?.id === 'reason') || (headCell?.id === 'earnings'))
                ? styles.headCellPlacement 
                : styles.headerLabel
             }
            >
              {headCell?.label}
            </TableSortLabel>
          }
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}


/* For get the ticket placements */
export function TicketPlacements({tickets, tableTitle}: any){
  let returnElement = <></>;
  // eslint-disable-next-line no-lone-blocks
  {
    ((tableTitle === 'manageticket') || (tableTitle === 'listticket') || (tableTitle === 'soldticket') || (tableTitle === 'delistandreturnticket') || (tableTitle === 'delistandunsoldticket'))
  ?   
  returnElement = <div className={styles.ticketPlacements}>
                    <div>
                      <div className={styles.valuesStyle}>{tickets?.tp_section ? tickets?.tp_section : '-'}</div>
                    </div>
                    <div>
                      <div className={styles.rowStyles}>{tickets?.tp_row ? tickets?.tp_row : '-'}</div>
                    </div>
                    <div>
                      <div className={styles.seatStyle}>{tickets?.tp_seat_no ?? '-'}</div>
                    </div>
                  </div>
  :  ((tableTitle === 'addTicketError') || (tableTitle === 'soldTicketError')||(tableTitle === 'publishTicketError') )
      ?
      returnElement = <div className={styles.ticketPlacements}>
                        <div>
                          <div className={styles.valuesStyle}>{tickets?.section ? tickets?.section : '-'}</div>
                        </div>
                        <div>
                          <div className={styles.rowStyles}>{tickets?.row ? tickets?.row : '-'}</div>
                        </div>
                        <div>
                          <div className={styles.seatStyle}>{tickets?.seatNo ? tickets?.seatNo : '-'}</div>
                        </div>
                      </div>  
      : (tableTitle === 'auditLogitixLogs') ?
       returnElement = <div className={styles.ticketPlacements}>
                        <div>
                          <div className={styles.valuesStyle}>{tickets?.section ? tickets?.section : '-'}</div>
                        </div>
                        <div>
                          <div className={styles.rowStyles}>{tickets?.row ? tickets?.row : '-'}</div>
                        </div>
                        <div>
                          <div className={styles.seatStyle}>{tickets?.seat ? tickets?.seat : '-'}</div>
                        </div>
                      </div>  
      :(tableTitle === 'stripePaymentError')
        ? 
        returnElement = <div className={styles.ticketPlacements}>
                          <div>
                            <div className={styles.valuesStyle}>
                              {tickets?.payment_transaction?.ticket_placement?.[0]?.tp_section
                              ? tickets?.payment_transaction?.ticket_placement?.[0]?.tp_section
                              : '-'
                              }
                            </div>
                          </div>
                          <div>
                            <div className={styles.rowStyles}>
                              {tickets?.payment_transaction?.ticket_placement?.[0]?.tp_row
                              ? tickets?.payment_transaction?.ticket_placement?.[0]?.tp_row
                              : '-'
                              }
                            </div>
                          </div>
                          <div>
                            <div className={styles.seatStyle}>
                              {tickets?.payment_transaction?.ticket_placement?.[0]?.tp_seat_no
                              ?? '-'
                              }
                            </div>
                          </div>
                        </div>
                        : (tableTitle === 'manualTicketsError')
                        ?
                          returnElement = <div className={styles.ticketPlacements}>
                          <div>
                            <div className={styles.valuesStyle}>
                              {tickets?.section
                              ? tickets?.section
                              : '-'
                              }
                            </div>
                          </div>
                          <div>
                            <div className={styles.rowStyles}>
                              {tickets?.row
                              ? tickets?.row
                              : '-'
                              }
                            </div>
                          </div>
                          <div>
                            <div className={styles.seatStyle}>
                              {tickets?.seat_no
                              ?? '-'
                              }
                            </div>
                          </div>
                        </div>
        : returnElement = <></>
  }
  return (returnElement);
}

export function checking(
  date: string,
  timeZone: string = 'America/Chicago',
  extras?: { e_time?: string | null; e_date_time_zone?: string | null },
) {
  const fields = {
    e_date: date,
    e_time_zone: timeZone || 'America/Chicago',
    e_time: extras?.e_time,
    e_date_time_zone: extras?.e_date_time_zone,
  };

  return {
    date: formatDbEventDate(fields, 'medium'),
    time: formatDbEventTime(fields, 'withZone'),
  };
}

export function splitLocation(location: string): { firstWord: string; remainingWords: string } {
  const words = location.split(', ');
  let firstWord = '';
  let remainingWords = '';

  if (words.length >= 2) {
    firstWord = words.shift()+"," || '';
    remainingWords = words.join(', ');
  } else {
    remainingWords = location;
  }

  return { firstWord, remainingWords };
}

//used for table
export function splitLocationForVenue(location: string){
  const parts = location.split(',');
  // Extract the desired parts
  const firstPart = `${parts[0]}${parts[1] ?  ',' : ''}`;
  const secondPart = `${parts[1]}${parts[2] ? ',' : ''}`;
  const thirdPart = parts.slice(2).join(', ');
  if(parts.length > 1){
    return (
      <div>
        {firstPart ? <div>{firstPart}</div> : ''}
        {secondPart ? <div>{secondPart}</div> : ''}
        {thirdPart ? <div>{thirdPart}</div> : ''}
      </div>
    );
  }else{
    return (
      <div>
        <p>{parts[0]}</p>
      </div>
    );
  }
}

//modifying amount values
export function formatNumberWithCommas(number: number): string {
  return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}


//calculating periods left

export function getTimeRemaining(providedTimeString: string,currentdate: string): string  {
  const localTime = moment.utc(providedTimeString).tz('America/Chicago');
  const formattedDate = localTime.format('ddd, DD MMM YYYY hh:mm A z');
  const currentDated = new Date(currentdate);
  const utcFormattedDate = currentDated.toUTCString();
  const CurrentformattedDate = moment.utc(utcFormattedDate).tz('America/Chicago').format('ddd, DD MMM YYYY hh:mm A z');
  const diffInMinutes = moment(formattedDate, 'ddd, DD MMM YYYY hh:mm A z').diff(moment(CurrentformattedDate, 'ddd, DD MMM YYYY hh:mm A z'), 'minutes');
  let timeRemaining: string | number;

// Display the time difference in a human-readable format
if (diffInMinutes < 0) {
  timeRemaining = "0 Days";
} else if (diffInMinutes < 60) {
  timeRemaining = `${diffInMinutes}  Minutes`;
} else if (diffInMinutes < 1440) { // 1440 minutes in a day (24 hours)
  const diffInHours = Math.floor(diffInMinutes / 60);
  timeRemaining = `${diffInHours}  Hours`;
} else {
  const diffInDays = Math.floor(diffInMinutes / 1440);
  timeRemaining = `${diffInDays}  Days`;
}
  return timeRemaining;
}

export const getFormattedDate = (date: Date) => {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/*convert the given day String to date format*/
export const convertStringToDate = (day: string) => {
  const today = new Date();
  let startdate = null;
  let enddate = null;

  if (day.toLowerCase() === 'today') {
    startdate = getFormattedDate(today);
    enddate = null;
  } else if (day.toLowerCase() === 'yesterday') {
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    startdate = getFormattedDate(yesterday);
    enddate = null;
  } else if (day.toLowerCase() === 'this month') {
    const startDate = new Date(today.getFullYear(), today.getMonth(), 1);
    const endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    startdate = getFormattedDate(startDate);
    enddate = getFormattedDate(endDate);
  } else if (day.toLowerCase() === 'last month') {
    const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const startDate = new Date(lastMonth.getFullYear(), lastMonth.getMonth(), 1);
    const endDate = new Date(lastMonth.getFullYear(), lastMonth.getMonth() + 1, 0);
    startdate = getFormattedDate(startDate);
    enddate = getFormattedDate(endDate);
  } else if (day.toLowerCase() === 'last 30 days') {
    const startDate = new Date(today);
    startDate.setDate(today.getDate() - 30);
    startdate = getFormattedDate(startDate);
    enddate = getFormattedDate(today);
  }
  return {startdate,enddate};
}
/*format the selected date in 'yyyy-mm-dd*/
export const formatDateWithHyphen = (date: Date): string =>{
  const day: number = date?.getDate();
  const month: number = date?.getMonth() + 1;
  const year: number = date?.getFullYear();

  const formattedDay: string = day < 10 ? `0${day}` : `${day}`;
  const formattedMonth: string = month < 10 ? `0${month}` : `${month}`;

  const dateformat = `${year}-${formattedMonth}-${formattedDay}`;
  return dateformat;
}

/* format the selected dates in 'dd/mm/yyyy */
export function formatDate(date: Date): string {
  const day: number = date.getDate();
  const month: number = date.getMonth() + 1;
  const year: number = date.getFullYear();

  const formattedDay: string = day < 10 ? `0${day}` : `${day}`;
  const formattedMonth: string = month < 10 ? `0${month}` : `${month}`;

  return `${formattedDay}/${formattedMonth}/${year}`;
}

/* show the selected dates from date picker */
export const showCustomRange = (startDate : string,endDate : string,Title: string, globalState: any) => {
  if(Title === 'list'){
    if(startDate !== '' && endDate !== ''){
      return `${formatDate(new Date(startDate))}-${formatDate(new Date(endDate))}`;
    }else if(globalState.listTicketFilter.startDateRange && globalState.listTicketFilter.endDateRange){
      return `${formatDate(new Date(globalState.listTicketFilter.startDateRange))}-${formatDate(new Date(globalState.listTicketFilter.endDateRange))}`;
    }
  }
  if(Title === 'sold'){
    if(startDate !== '' && endDate !== ''){
      return `${formatDate(new Date(startDate))}-${formatDate(new Date(endDate))}`;
    }else if(globalState.soldTicketFilter.startDateRange && globalState.soldTicketFilter.endDateRange){
      return `${formatDate(new Date(globalState.soldTicketFilter.startDateRange))}-${formatDate(new Date(globalState.soldTicketFilter.endDateRange))}`;
    }
  }
  if(Title === 'delistandreturn'){
    if(startDate !== '' && endDate !== ''){
      return `${formatDate(new Date(startDate))}-${formatDate(new Date(endDate))}`;
    }else if(globalState.delistAndReturnTicketFilter.startDateRange && globalState.delistAndReturnTicketFilter.endDateRange){
      return `${formatDate(new Date(globalState.delistAndReturnTicketFilter.startDateRange))}-${formatDate(new Date(globalState.delistAndReturnTicketFilter.endDateRange))}`;
    }
  }
  if(Title === 'delistandunsold'){
    if(startDate !== '' && endDate !== ''){
      return `${formatDate(new Date(startDate))}-${formatDate(new Date(endDate))}`;
    }else if(globalState.unsoldTicketFilter.startDateRange && globalState.unsoldTicketFilter.endDateRange){
      return `${formatDate(new Date(globalState.unsoldTicketFilter.startDateRange))}-${formatDate(new Date(globalState.unsoldTicketFilter.endDateRange))}`;
    }
  }else{
    if(startDate !== '' && endDate !== ''){
      return `${formatDate(new Date(startDate))}-${formatDate(new Date(endDate))}`;
    }else if(globalState.manageTicketFilter.startDateRange && globalState.manageTicketFilter.endDateRange){
      return `${formatDate(new Date(globalState.manageTicketFilter.startDateRange))}-${formatDate(new Date(globalState.manageTicketFilter.endDateRange))}`;
    }
  }
}

/* Return the date related filters JSX*/
export function DateFilter(props: any){
  const{
    handleClickDays,
    showDayTick,
    handleClickCustomRange,
    showCustomRangeValues,
    showDatePicker,
    startDate,
    endDate,
    handleClickOutside,
    onChange
  } = props;
  const {bluetick,rightChevronIcon} = images;
  return (
    <div className={filterStyles.validate}>
                <b className={filterStyles.validate1}>Date</b>
                <div className={filterStyles.dateFilter}>
                  <div className={filterStyles.today}>
                    <div
                      className={filterStyles.today1}
                      onClick={() => {
                        handleClickDays("Today");
                      }}
                    >
                      Today
                    </div>
                    {showDayTick() === "Today" && (
                      <div>
                        <img src={bluetick} alt="clicked" data-testid="greenTik"/>
                      </div>
                    )}
                  </div>
                  <div className={filterStyles.today}>
                    <div
                      className={filterStyles.today1}
                      onClick={() => {
                        handleClickDays("Yesterday");
                      }}
                    >
                      Yesterday
                    </div>
                    {showDayTick() === "Yesterday" && (
                      <div>
                        <img src={bluetick} alt="clicked" />
                      </div>
                    )}
                  </div>
                  <div className={filterStyles.today}>
                    <div
                      className={filterStyles.today1}
                      onClick={() => {
                        handleClickDays("Last 30 Days");
                      }}
                    >
                      Last 30 Days
                    </div>
                    {showDayTick() === "Last 30 Days" && (
                      <div>
                        <img src={bluetick} alt="clicked" />
                      </div>
                    )}
                  </div>
                  <div className={filterStyles.today}>
                    <div
                      className={filterStyles.today1}
                      onClick={() => {
                        handleClickDays("This Month");
                      }}
                    >
                      This Month
                    </div>
                    {showDayTick() === "This Month" && (
                      <div>
                        <img src={bluetick} alt="clicked" />
                      </div>
                    )}
                  </div>
                  <div className={filterStyles.today}>
                    <div
                      className={filterStyles.today1}
                      onClick={() => {
                        handleClickDays("Last Month");
                      }}
                    >
                      Last Month
                    </div>
                    {showDayTick() === "Last Month" && (
                      <div>
                        <img src={bluetick} alt="clicked" />
                      </div>
                    )}
                  </div>
                  <div
                    className={filterStyles.customRange}
                    onClick={handleClickCustomRange}
                  >
                    <div className={filterStyles.today1} id="customrange">
                      Custom Range 
                      {showCustomRangeValues()}
                    </div>
                    <img
                      className={filterStyles.roundedOutlineRadioUnse}
                      alt="rightSideArrowIcon"
                      src={rightChevronIcon}
                    />
                    <div className={filterStyles.datepicker}>
                  
                      {showDatePicker && (
                        <DatePicker
                          selected={startDate}
                          onChange={onChange}
                          startDate={startDate}
                          endDate={endDate}
                          selectsRange = {true}
                          inline = {true}
                          onClickOutside={handleClickOutside}
                          className={filterStyles.datepicker}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
  );
}

/* Return the apply, reset buttons for filter dropdown */
export function ResetApplyButtons(props: any){
  const {handleCancel,handleSubmit} =props;
  return(
  <div className={filterStyles.cta}>
    <CancelButton handleCancel={handleCancel} />
    <SubmitButton handleSubmit= {handleSubmit}/>
  </div>);
}

/* Dropdown for league list in filter dropdown */
export const LeagueListMenu = (props: any) => {
  const {anchorEl,open,handleCloseMenu,handleSelectleague,selectedLeague,leagueslistData} = props;
  return (
    <Menu
    id="long-menu"
    MenuListProps={{
      "aria-labelledby": "long-button",
      disablePadding: true,
    }}
    transformOrigin={{
      horizontal: "left",
      vertical: "top",
    }}
    anchorOrigin={{
      horizontal: "left",
      vertical: "bottom",
    }}
    anchorEl={anchorEl}
    open={open}
    onClose={handleCloseMenu}
    classes={{
      paper: filterStyles.leaguedropdown,
      list: filterStyles.leagueListStyle
    }}
  >
    {leagueslistData && leagueslistData?.map((league: LeagueObjectType) => {
      return (
        <MenuItem
          key={league?.l_id}
          onClick={() => handleSelectleague(league)}
          className={filterStyles.menuItem}
          classes={{
            root: `${filterStyles.menuitemhover} ${selectedLeague === league?.l_name ? filterStyles.menuitemBg : ''}`,
          }}
          disableRipple
        >
          {league?.l_name}
        </MenuItem>
      )
    })}
  </Menu>
  );
}

export const AffiliatePayoutTypeListMenu = (props: any) => {
  const {anchorEl,open,handleCloseMenu,handleSelectAffiliateType,selectedType,affiliateTypeListData} = props;
  return (
    <Menu
    id="long-menu"
    MenuListProps={{
      "aria-labelledby": "long-button",
      disablePadding: true,
    }}
    transformOrigin={{
      horizontal: "left",
      vertical: "top",
    }}
    anchorOrigin={{
      horizontal: "left",
      vertical: "bottom",
    }}
    anchorEl={anchorEl}
    open={open}
    onClose={handleCloseMenu}
    classes={{
      paper: filterStyles.affiliateDropdownModule,
      list: filterStyles.leagueListStyle
    }}
  >
    {affiliateTypeListData && affiliateTypeListData?.map((type: AffiliateType,index: number) => {
      return (
        <MenuItem
          key={index}
          onClick={() => handleSelectAffiliateType(type)}
          className={filterStyles.menuItem}
          classes={{
            root: `${filterStyles.menuitemhover} ${selectedType === type?.name ? filterStyles.menuitemBg : ''}`,
          }}
          disableRipple
        >
          {type?.name}
        </MenuItem>
      )
    })}
  </Menu>
  );
}

export const AffiliateTypeListMenu = (props: any) => {
  const {anchorEl,open,handleCloseMenu,handleSelectAffiliateType,selectedType,affiliateTypeListData} = props;
  return (
    <Menu
    id="long-menu"
    MenuListProps={{
      "aria-labelledby": "long-button",
      disablePadding: true,
    }}
    transformOrigin={{
      horizontal: "left",
      vertical: "top",
    }}
    anchorOrigin={{
      horizontal: "left",
      vertical: "bottom",
    }}
    anchorEl={anchorEl}
    open={open}
    onClose={handleCloseMenu}
    classes={{
      paper: filterStyles.affiliateDropdownModule,
      list: filterStyles.leagueListStyle
    }}
  >
    {affiliateTypeListData && affiliateTypeListData?.map((type: AffiliateType,index: number) => {
      return (
        <MenuItem
          key={index}
          onClick={() => handleSelectAffiliateType(type)}
          className={filterStyles.menuItem}
          classes={{
            root: `${filterStyles.menuitemhover} ${selectedType === type?.name ? filterStyles.menuitemBg : ''}`,
          }}
          disableRipple
        >
          {type?.name}
        </MenuItem>
      )
    })}
  </Menu>
  );
}

export const AppVersionMenu = (props: any) => {
  const {anchorElApp,open,handleCloseMenu, appVerisonList, handleSelectappversion,loading} = props;
  return (
    <Menu
    id="long-menu"
    MenuListProps={{
      "aria-labelledby": "long-button",
      disablePadding: true,
    }}
    transformOrigin={{
      horizontal: "left",
      vertical: "top",
    }}
    anchorOrigin={{
      horizontal: "left",
      vertical: "bottom",
    }}
    anchorEl={anchorElApp}
    open={open}
    onClose={handleCloseMenu}
    classes={{
      paper: filterStyles.appversiondropdown,
      list: filterStyles.leagueListStyle
    }}
  >
   {loading ? (
 <div className={filterStyles.loader}> <CircularProgress color="primary" size={35} /></div>
) : (
  appVerisonList && appVerisonList.map((appversion: AppVersionObjectType, index: number) => (
    <MenuItem
      key={index}
      onClick={() => handleSelectappversion(appversion)}
      className={filterStyles.menuItem}
      disableRipple
      classes={{
        root : filterStyles.menuitemhover
      }}
    >
      {appversion.app_os_name}
    </MenuItem>
  ))
)}

  </Menu>
  );
}

export interface AppVersionObjectType {
  app_os_name: string;
  app_should_force_update: boolean;
  app_version: string;
}

export interface AppVersionList {
  app_version_info : AppVersionObjectType[]
}

//Calculating last login
export const createdAtFormatDateTime = (data: string) => {

  const date: Date = new Date(data);

  // Convert to 'America/Chicago' timezone
  const chicagoTime: moment.Moment = moment.tz(date, 'America/Chicago');

  // Format the date without including the timezone
  const formattedDate: string = chicagoTime.format('MMM D, YYYY, hh:mm:ss A z');

  // const replaceString : string = formattedDate.replace('CST','CDT');
  const parts = formattedDate.split(',');

  const firstPart = `${parts[0]}, ${parts[1]}`;
  const secondPart = `${parts[2]}`;

  return [firstPart, secondPart];
}

export const monthNames = [
  'January', 'February', 'March', 'April',
  'May', 'June', 'July', 'August',
  'September', 'October', 'November', 'December'
];

export const isSubscribeDomain = (): boolean => {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  const result = host.includes('subscribe');
  return result;
};

export const generateDynamicLinkForNotVerifiedUsers = async (userDetails: rowsType | undefined) => {
  const API_KEY = process.env.REACT_APP_API_KEY;
  const firebaseDynamicLinkAPI = `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${API_KEY}`;
  const longDynamicLink = `https://quickasyst.page.link/PZXe?id=${userDetails?.u_email_id}`;
  const androidPackageName = 'com.quickasyst'
  const iosBundleId = 'com.quickasystdev'
  
  const bodyRequest = {
    dynamicLinkInfo: {
      dynamicLinkDomain: 'quickasyst.page.link',
      link: longDynamicLink,
      androidInfo: {
        androidPackageName,
      },
      iosInfo: {
        iosBundleId
      }
    },
    suffix: {
      option: "SHORT"
    }
  };

  try {
    const response = await axios.post(firebaseDynamicLinkAPI, bodyRequest);
    const shortLink = response.data.shortLink;
    return shortLink;
  } catch (error) {
    return null;
  }
}


export function ErrorTicketEventDateFormat({dateValue}: any) {
  // Parse the input date using moment.js
  var parsedDate = moment(dateValue, dateValue?.includes('/') ? "ddd, MM/DD/YYYY h:mm A z" : "ddd, DD MMM YYYY @ hh:mm A z");
  var formattedDate = parsedDate.format('ddd, DD MMM YYYY');
  var formattedTime = parsedDate.format('hh:mm A z');
  
  return (
  <>
    <div>{formattedDate}</div>
    <div>{formattedTime}</div>
  </>);
}


export function formatDates(startDate: number, endDate: Date): { formattedStartDate: string, formattedEndDate: string } {
  const originalStartDate = new Date(startDate);
  const originalEndDate = new Date(endDate);
  const formattedStartDate = moment(originalStartDate)
    .startOf("day")
    .local()
    .format("YYYY-MM-DDTHH:mm:ssZ");
  const formattedEndDate = moment(originalEndDate)
    .endOf("day")
    .local()
    .format("YYYY-MM-DDTHH:mm:ssZ");
  return { formattedStartDate, formattedEndDate };
}

export function htmlToText(html: string){
// Create an instance of the parser
const htmlToReactParser = new HtmlToReactParser();
// Example HTML content
const htmlContent = html;
// Parse HTML content into React elements
const reactElement = htmlToReactParser.parse(htmlContent);
return reactElement
}

export const oneMonthAgo=()=>{
  const oneMonthAgo = new Date();
oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
return oneMonthAgo;
}

export const getDayBeforeYesterday = () => {
    const date = new Date();
    date.setDate(date.getDate() - 2);
    return date;
  };
export const getToday = () => {
    const date = new Date();
    date.setDate(date.getDate());
    return date;
};

export const yearStart=()=>{
  const currentDate = new Date();
  currentDate.setMonth(0); 
  currentDate.setDate(1);  
return currentDate;
}
export const yearEnd=()=>{
  const currentDate = new Date();
  currentDate.setMonth(11); 
  currentDate.setDate(31);  
return currentDate;
}

export const roundToFixed = (num: number, decimalPlaces: number) => {
  const factor = Math.pow(10, decimalPlaces);
  return (Math.round(num * factor) / factor).toFixed(decimalPlaces);
}


export const formatUnderScore = (input: string) => {
  const wordsSplit = input.split('_').join(" ");
  return wordsSplit?.split(" ").map((s:string) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()).join(" ") ?? wordsSplit
}

export const roles = {
  AFFILIATER_ADMIN: 'affiliater_admin',
  ADMIN: 'admin',
  MARKETING_USER: 'marketing_user',
  SUB_ADMIN: 'sub_admin',
  USER: 'user',
  SUPER_USER: 'super_user',
  LOGITIX_USER : 'logitix_user'
}

/**
 * Resolves which portal role to use for Hasura (x-hasura-role) from u_allowed_roles.
 * Sub-admin must win over marketing_user when both are present — the old `.find()` on array
 * order picked marketing_user first and scoped affiliate_details to aCreatedBy, yielding an empty list.
 */
export const resolvePreferredPortalRole = (
  allowedRoles: string[] | null | undefined,
  dbRole?: string | null
): string => {
  const allowed = Array.isArray(allowedRoles) ? allowedRoles : [];
  if (dbRole === roles.SUB_ADMIN && allowed.includes(roles.SUB_ADMIN)) {
    return roles.SUB_ADMIN;
  }
  const priority = [
    roles.AFFILIATER_ADMIN,
    roles.SUB_ADMIN,
    roles.SUPER_USER,
    roles.MARKETING_USER,
  ];
  const hit = priority.find((r) => allowed.includes(r));
  if (hit) return hit;
  if (dbRole) return dbRole;
  return allowed[0] || "";
};

export const getRoleFromDomain = () => {
  const host = window.location.host;

  if (host.includes("user")) return roles.SUPER_USER;
  if (host.includes("admin")) return roles.ADMIN;
  // if (host.includes("localhost")) return roles.SUPER_USER;
  return roles.USER;
  }

const SUPER_USER_ALLOWED = [roles.SUPER_USER];
export const ADMIN_PORTAL_ALLOWED = [
  roles.ADMIN,
  roles.AFFILIATER_ADMIN,
  roles.MARKETING_USER,
  roles.SUB_ADMIN,
  roles.LOGITIX_USER,
];

/** Staff roles with the same operational permissions as admin / sub-admin in the portal. */
export const STAFF_ADMIN_EQUIVALENT_ROLES = [roles.ADMIN, roles.SUB_ADMIN, roles.MARKETING_USER];

export const isStaffAdminEquivalent = (userRole: string) =>
  STAFF_ADMIN_EQUIVALENT_ROLES.includes(userRole);

/**
 * Active QA/staff emails for return-email pickers.
 * Keeps admin-equivalent roles, skips inactive/deleted users, de-dupes, and sorts.
 */
export const getQAOpsReturnEmailOptions = (
  rows: Array<{
    u_role?: string | null;
    u_email_id?: string | null;
    u_deleted_at?: string | null;
    u_is_active?: boolean | null;
  }> = [],
): string[] => {
  const emails = new Set<string>();
  for (const row of rows || []) {
    if (row?.u_deleted_at) continue;
    if (row?.u_is_active === false) continue;
    const role = String(row?.u_role || '').trim();
    if (!isStaffAdminEquivalent(role)) continue;
    const email = String(row?.u_email_id || '').trim();
    if (!email) continue;
    emails.add(email);
  }
  return Array.from(emails).sort((a, b) => a.localeCompare(b));
};

/** Roles that can open My Account / Change Password from the header profile menu. */
export const PROFILE_MENU_ROLES = [...ADMIN_PORTAL_ALLOWED, roles.SUPER_USER];

/** Mail Parser / Error Dashboard tables show user name & email for staff roles (not logitix_user). */
export const canViewMailParserUserColumns = (userRole: string) =>
  [roles.ADMIN, roles.AFFILIATER_ADMIN, roles.SUB_ADMIN, roles.MARKETING_USER].includes(userRole);

/** Transfer / Payout / User Tickets mail-parser tabs — same staff roles as user columns. */
export const canViewMailParserExtendedTabs = canViewMailParserUserColumns;

/** Admin portal Manage Tickets route (all staff roles except logitix). */
export const MANAGE_TICKETS_PATH = "/managetickets";

/** Legacy tickets route — logitix_user only. */
export const LEGACY_TICKETS_PATH = "/tickets";

/** Resolve tickets page path by role. Admin portal → Manage Tickets; logitix → legacy Tickets. */
export const getTicketsPagePath = (userRole: string): string =>
  userRole === roles.LOGITIX_USER ? LEGACY_TICKETS_PATH : MANAGE_TICKETS_PATH;

/** Mail Parser "View" navigates to the role-appropriate tickets page. */
export const getMailParserTicketViewPath = getTicketsPagePath;

/** Legacy mail-parser error status → Manage Tickets tab (new UI). */
export const getManageTicketsTabFromErrorStatus = (status: string): string => {
  switch (status) {
    case "List":
      return "Listed";
    case "Sold":
    case "PaidManuallyViaQA":
    case "QADeniedPayout":
    case "UnderReview":
      return "Sold";
    case "Return":
    case "Delist":
    case "DelistInProgress":
      return "Delisted";
    case "Unsold":
      return "Unsold";
    case "Verified":
      return "Verified";
    case "ToBeVerified":
    default:
      return "Verification";
  }
};

/** Build mail-parser error filter state; clears stale tp id fields from prior views. */
export const buildMailParserTicketErrorState = (
  error: Record<string, unknown>,
  payload: {
    text: string;
    status: string;
    ticketPlacementId?: string[] | null;
    approximateTpArray?: string[] | null;
  },
) => ({
  ...error,
  text: payload.text,
  errorClicked: true,
  status: payload.status,
  ticketPlacementId: payload.ticketPlacementId ?? null,
  approximateTpArray: payload.approximateTpArray ?? null,
  userError: false,
});

/** Resolve tp ids from mail-parser error global state. */
export const getMailParserErrorTpIds = (error: {
  approximateTpArray?: string[] | null;
  ticketPlacementId?: string[] | null;
} | null | undefined): string[] | null => {
  if (!error) return null;
  if (Array.isArray(error.approximateTpArray) && error.approximateTpArray.length > 0) {
    return error.approximateTpArray;
  }
  if (Array.isArray(error.ticketPlacementId) && error.ticketPlacementId.length > 0) {
    return error.ticketPlacementId;
  }
  return null;
};

export const isRoleAllowed=(role: string, domainRole: string) =>{
  if (domainRole === roles.SUPER_USER) {
    return SUPER_USER_ALLOWED.includes(role);
  }
  return ADMIN_PORTAL_ALLOWED.includes(role);
}